module.exports = __webpack_public_path__ + "static/media/Pic-0397.26530aa0.jpg";